module.exports = __webpack_public_path__ + "static/img/IMG_20160224_124656.2cbe0125.jpg";